import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ee702c28"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee702c28')) {
      api.createRecord('ee702c28', component.options)
    } else {
      api.reload('ee702c28', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=ee702c28", function () {
      api.rerender('ee702c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/suppliers/view/layout/Index.vue"
export default component.exports